module.exports = __webpack_public_path__ + "static/img/20017 (4).3c2807f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20017 (4).webp
// module id = Rtjr
// module chunks = 14